(function () {
  'use strict';

  var SECTION_SELECTOR = '.product-section[data-product-handle*="build-your-"][data-product-handle*="-gallon-tin-"]';
  var initialized = new WeakSet();

  function normalizedText(value) {
    return String(value || '')
      .replace(/\s*\(\s*\+?\$[\d,.]+\s*\)\s*$/i, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function designFromAlt(alt) {
    var parts = String(alt || '').split('|');
    if (parts.length < 3 || !/^\s*TIN-/i.test(parts[0])) {
      return '';
    }
    return normalizedText(parts[1]);
  }

  function buildMediaMap(section) {
    var map = {};
    var thumbs = section.querySelectorAll('.product__thumb-item');

    Array.prototype.forEach.call(thumbs, function (thumb, fallbackIndex) {
      var image = thumb.querySelector('img[alt]');
      var design = image ? designFromAlt(image.getAttribute('alt')) : '';
      if (!design) {
        return;
      }

      var rawIndex = thumb.getAttribute('data-index');
      var index = rawIndex === null ? fallbackIndex : parseInt(rawIndex, 10);
      if (!Number.isNaN(index)) {
        map[design] = index;
      }
    });

    return map;
  }

  function selectedOptionText(select) {
    if (!select || select.selectedIndex < 0) {
      return '';
    }
    return normalizedText(select.options[select.selectedIndex].textContent);
  }

  function designSelect(section, mediaMap) {
    var selects = section.querySelectorAll('select');
    var best = null;
    var bestScore = 0;

    Array.prototype.forEach.call(selects, function (select) {
      var score = 0;
      Array.prototype.forEach.call(select.options || [], function (option) {
        if (Object.prototype.hasOwnProperty.call(mediaMap, normalizedText(option.textContent))) {
          score += 1;
        }
      });

      var id = select.getAttribute('id');
      var label = null;
      if (id) {
        Array.prototype.some.call(section.querySelectorAll('label'), function (candidate) {
          if (candidate.htmlFor === id) {
            label = candidate;
            return true;
          }
          return false;
        });
      }
      var labelText = normalizedText(label ? label.textContent : '');
      if (labelText.indexOf('tin design') !== -1) {
        score += 100;
      }

      if (score > bestScore) {
        best = select;
        bestScore = score;
      }
    });

    return bestScore > 0 ? best : null;
  }

  function goToDesign(section) {
    var mediaMap = buildMediaMap(section);
    var select = designSelect(section, mediaMap);
    if (!select) {
      return false;
    }

    var design = selectedOptionText(select);
    var index = mediaMap[design];
    if (typeof index !== 'number') {
      return false;
    }

    var sectionId = section.getAttribute('data-section-id');
    var main = document.getElementById('ProductPhotos-' + sectionId);
    var thumbs = document.getElementById('ProductThumbs-' + sectionId);
    var $ = window.theme && window.theme.jQuery ? window.theme.jQuery : window.jQuery;

    if (!$ || !main || !$(main).hasClass('slick-initialized')) {
      return false;
    }

    var current = main.querySelector('.slick-slide.slick-current');
    var currentIndex = current ? parseInt(current.getAttribute('data-slick-index'), 10) : NaN;
    if (section.getAttribute('data-selected-tin-design') === design && currentIndex === index) {
      return true;
    }

    $(main).slick('slickSetOption', 'swipe', false);
    $(main).slick('slickSetOption', 'draggable', false);
    $(main).slick('slickSetOption', 'touchMove', false);
    $(main).slick('slickGoTo', index, true);
    if (thumbs && $(thumbs).hasClass('slick-initialized')) {
      $(thumbs).slick('slickGoTo', index, true);
    }

    section.setAttribute('data-selected-tin-design', design);
    return true;
  }

  function initialize(section) {
    if (initialized.has(section)) {
      return;
    }
    initialized.add(section);

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (goToDesign(section) || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 250);

    // Capture the selection before app-owned handlers can replace the control
    // or stop the event from bubbling during a Simple Bundles rerender.
    section.addEventListener('change', function () {
      window.requestAnimationFrame(function () {
        goToDesign(section);
      });
    }, true);

    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        goToDesign(section);
      });
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  function initializeAll() {
    Array.prototype.forEach.call(document.querySelectorAll(SECTION_SELECTOR), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
